import config from '../../config.json';
import { loadUser as loadUserApi, logout as logoutApi } from '../../api';
import RedirectToLogin from '../../components/RedirectToLogin';

import * as actionTypes from '../actionTypes';

export const setUserData = ({ data }) => {
  return {
    type: actionTypes.USER_SET_DATA,
    data,
  };
};
export const startUserLoading = () => {
  return {
    type: actionTypes.USER_START_LOADING,
  };
};
export const finishUserLoading = () => {
  return {
    type: actionTypes.USER_FINISH_LOADING,
  };
};
export const setUserError = ({ error }) => {
  return {
    type: actionTypes.USER_SET_ERROR,
    error,
  };
};

export const loadUser = () => {
  return async (d) => {
    d(startUserLoading());

    try {
      const data = await loadUserApi();
      if (data) {
        d(setUserData({ data }));
        d(finishUserLoading());
      } else {
        RedirectToLogin();
      }
    } catch (error) {
      d(setUserError(error));
      RedirectToLogin();
    }
  };
};

export const logout = () => {
  return async (d) => {
    d(startUserLoading());

    try {
      await logoutApi();
      d(setUserData({ data: null }));
      window.location.replace(`${config.saml.logoutUrl}`);
    } catch (error) {
      d(setUserError(error));
    } finally {
      d(finishUserLoading());
    }
  };
};
